"use client";

import { cn } from "@/lib/utils";
import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "secondary" | "outline" | "ghost";
    size?: "default" | "sm" | "lg" | "icon";
}

export function Button({ className, variant = "primary", size = "default", children, ...props }: ButtonProps) {
    const baseStyles = "cursor-pointer inline-flex items-center justify-center rounded-md font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-science-blue disabled:opacity-50 disabled:pointer-events-none active:translate-y-[1px]";

    const variants = {
        primary: "bg-science-blue text-white shadow-sm hover:bg-science-blue/90 border border-transparent hover:shadow-md",
        secondary: "bg-brand-navy text-white hover:bg-brand-navy/90 border border-transparent shadow-sm",
        outline: "border border-slate-300 text-slate-700 bg-white hover:bg-slate-50 hover:text-brand-navy hover:border-slate-400",
        ghost: "bg-transparent text-slate-600 hover:bg-slate-100 hover:text-brand-navy font-medium"
    };

    const sizes = {
        default: "h-10 px-5 text-sm",
        sm: "h-8 px-3 text-xs rounded-sm",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
    };

    return (
        <button
            className={cn(baseStyles, variants[variant], sizes[size], className)}
            {...props}
        >
            {children}
        </button>
    );
}
